// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__BbTCe","galleryContainer":"Gallery_galleryContainer__IcXMe","slide":"Gallery_slide__O0k-X"};